<template>
  <div class="d-flex align-center flex-wrap py-2">
    <v-avatar color="primary" size="44" class="mr-4">
      <v-icon dark>{{ icon }}</v-icon>
    </v-avatar>
    <div>
      <div class="text-h6 font-weight-bold" style="color: var(--color-ink)">{{ title }}</div>
      <div v-if="subtitle" class="text-body-2" style="opacity: 0.6">{{ subtitle }}</div>
    </div>
    <v-spacer></v-spacer>
    <div class="d-flex align-center">
      <slot></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: "AppPageHeader",
  props: {
    icon: { type: String, default: "mdi-view-dashboard" },
    title: { type: String, required: true },
    subtitle: { type: String, default: "" },
  },
};
</script>
